/**
 * Признак поискового бота/краулера по User-Agent.
 *
 * Используется там, где визит бота не должен попадать в статистику и в
 * мониторинг: краулеры массово обходят каталог и дают на порядок больше
 * событий, чем живые пользователи, не отражая при этом реальных проблем.
 */

// Токены ботов ищем именно в таком виде (специфичные, чтобы не задеть
// реальные браузеры — напр. YaBrowser у Яндекс.Браузера не содержит "bot").
const CRAWLER_UA_REGEX =
  /bot\b|crawl|spider|slurp|mediapartners|facebookexternalhit|meta-externalagent|bingpreview|yandex(bot|images|metrika|renderresourcesbot|accessibilitybot)|baiduspider|duckduckbot|embedly|quora link preview|whatsapp|telegrambot|vkshare|applebot|google-inspectiontool|gptbot|claudebot|petalbot|semrushbot|ahrefsbot|dotbot|headless/i;

export function isCrawler(): boolean {
  try {
    if (typeof navigator === "undefined" || !navigator.userAgent) {
      return false;
    }
    return CRAWLER_UA_REGEX.test(navigator.userAgent);
  } catch {
    return false;
  }
}
